import systemSettingApi from '@/api/system-setting'
import store from '@/store'
import { generateFormHandlerMutations } from '@/helpers/forms'

const getDefaultState = () => ({
  parts: 0,
  partLength: 0,
  plaintext: '',
  errors: {
    errors: [],
    commonErrors: []
  },
})

const state = getDefaultState()

const getters = {}

const actions = {
  fetch({ commit }) {
    commit("FORM_RESET");
    systemSettingApi.getReferralCodeSetting()
      .then(({ data }) => commit('REFERRAL_CODE_SETTING_FETCHED', data))
      .catch(err => commit('REFERRAL_CODE_SETTING_FETCH_FAILED', err))
  },
  update({ commit }) {
    return systemSettingApi.updateReferralCodeSetting(state)
      .then(({ data }) => commit('REFERRAL_CODE_SETTING_UPDATED', data))
      .catch((error) => {
        commit('REFERRAL_CODE_SETTING_UPDATE_FAILED', error.response.data)
        throw error;
      })
  },
  resetForm({ commit }) {
    commit("FORM_RESET")
  },
}

const mutations = {
  REFERRAL_CODE_SETTING_UPDATED() {
    store.dispatch('message/success', 'APPLICATION_DESCRIPTION.updated')
  },
  REFERRAL_CODE_SETTING_UPDATE_FAILED(state, errors) {
    Object.assign(state.errors, errors)
    store.dispatch('message/error', 'APPLICATION_DESCRIPTION.failedUpdate')
  },
  FORM_RESET(state) {
    Object.assign(state, getDefaultState())
  },
  REFERRAL_CODE_SETTING_FETCHED(state, data) {
    Object.assign(state, data)
  },
  ...generateFormHandlerMutations(state)
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
